"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.USER_MANAGEMENT_ROLES = void 0;
var USER_MANAGEMENT_ROLES;
(function (USER_MANAGEMENT_ROLES) {
    USER_MANAGEMENT_ROLES["SEARCH"] = "search";
    USER_MANAGEMENT_ROLES["VIEW"] = "view";
    USER_MANAGEMENT_ROLES["CREATE"] = "create";
    USER_MANAGEMENT_ROLES["MODIFY"] = "modify";
    USER_MANAGEMENT_ROLES["DELETE"] = "delete";
})(USER_MANAGEMENT_ROLES = exports.USER_MANAGEMENT_ROLES || (exports.USER_MANAGEMENT_ROLES = {}));
//# sourceMappingURL=user-management.roles.js.map